<template>
    <b-modal ref="fork-modal" id="fork-modal" header-class="border-0 pt-4 pb-1" hide-footer @show="resetModal" dialog-class="full-modal">
        <template v-slot:modal-header="{ close }">
            <p class="text-primary text-bold">{{trans(`courses.${transTarget}.take_shortcut_title`)}}</p>
            <b-icon icon="x" v-on:click="close()" scale="2" class="close-button" variant="primary"></b-icon>
        </template>

        <template v-slot:default="{ close }">
            <div class="row">
                <div class="col-12" v-if="answerIndex === 0">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="/images/master-dashboard/shortcut1.svg" alt="..." class="pb-4">
                            <p class="text-primary text-bold">{{trans(`courses.${transTarget}.advance_faster`)}}</p>
                            <p class="text-primary">{{trans(`courses.${transTarget}.shortcut_description`)}}</p>
                        </div>

                        <div class="col-12 d-flex justify-content-between">
                            <b-button variant="light" v-on:click="close()" class="border-0 text-bold">{{trans('courses.new_dashboard.cancel')}}</b-button>
                            <b-button @click="trackMixpanelEventAndIncrementAnswer" variant="secondary">{{trans(`courses.${transTarget}.continue`)}}</b-button>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="answerIndex === 1">
                    <div class="row">
                        <div class="col-12">
                            <p class="text-bold">{{trans(`courses.${transTarget}.answer_question`)}}</p>
                            <p>{{fork.questionText}}</p>

                            <b-form-group label-cols="12">
                                <b-form-radio
                                        v-for="answer in fork.answers"
                                        v-bind:key="answer.relatedModuleId"
                                        v-bind:value="answer.relatedModuleId"
                                        v-model="selected"
                                        button
                                        name="radios-btn-default"
                                        class="mb-3 w-100"
                                        button-variant="outline-secondary btn-block"
                                >
                                    {{answer.answerText}}
                                </b-form-radio>
                            </b-form-group>
                        </div>

                        <div class="col-12 d-flex justify-content-between">
                            <b-button variant="light" v-on:click="close()" class="border-0 text-bold">{{trans('courses.new_dashboard.cancel')}}</b-button>
                            <b-button :disabled="selected === '' || isLoading" @click="answer" variant="secondary">{{trans('courses.new_dashboard.confirm')}}</b-button>
                        </div>
                    </div>
                </div>

                <div v-if="answerIndex === 2" class="col-12">
                    <div class="col-12 text-center">
                        <img src="/images/master-dashboard/shortcut2.svg" alt="..." class="pb-4">
                        <p class="text-primary text-bold">{{trans(`courses.${transTarget}.thanks`)}}</p>
                        <p class="text-primary">{{trans(`courses.${transTarget}.fork_finish`)}}</p>
                    </div>

                    <div class="col-12 d-flex justify-content-end">
                        <b-button @click="refreshContent" variant="secondary" class="text-uppercase">{{trans(`courses.${transTarget}.continue`)}}</b-button>
                    </div>
                </div>
            </div>
        </template>

    </b-modal>
</template>

<script>
    export default {
        props:{
            fork: Object,
            index: Number,
            answerFork: Function,
            phaseId: Number,
            transTarget: String,
        },
        data(){
            return {
                answerIndex: 0,
                selected: '',
                isLoading: false
            }
        },
        methods: {
            resetModal(){
                this.answerIndex = 0;
                this.selected = '';
            },
            answer(){
                trackEvent('shortcutConfirmation', {
                    forkAnswer : this.selected,
                    phase: this.phaseId
                });
                
                this.isLoading = true;
                var self = this;
                this.$axios.post('/api/rest/programs/user_fork/save',{
                    related_module_id: this.selected,
                    phase_id: this.phaseId
                })
                .then(()=>{
                    self.isLoading = false;
                    self.answerIndex++;
                })
                .catch(e=>{
                    self.isLoading = false;
                    console.log(e);
                });
            },
            refreshContent(){
                this.$refs['fork-modal'].hide();
                this.answerFork();
            },
            trackMixpanelEventAndIncrementAnswer(){
                this.answerIndex++;
                trackEvent('shortcutInstruction', {
                    phase: this.phaseId
                });
            }
        }
    }
</script>
